import { ReduxRouter } from "@lagunovsky/redux-react-router";
import React, { useEffect } from "react";
import { Provider, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { PersistGate } from "redux-persist/es/integration/react";
import Navigation from "./navigation";
import { IntercomProvider } from "react-use-intercom";
import { history } from "./config/history";
import { store, persistor } from "./redux/toolkit/store";

const routerSelector = (state) => state.router;

const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_ID;

const SegmentIdentify = () => {
  const userId = useSelector((state) => state.session?.user?.id);
  const accountId = useSelector((state) => state.session?.account?.id);
  const organisationId = useSelector(
    (state) => state.session?.account?.organisation?.id,
  );

  useEffect(() => {
    const { user, productAccess, account } = store.getState().session;

    if (!productAccess?.includes("admin") || !user) return;

    const { id, email, firstName, lastName, createdAt } = user;

    window.analytics.identify(id, {
      email,
      firstName,
      lastName,
      name: `${firstName} ${lastName}`,
      createdAt,
      id,
    });

    const segmentData = {
      groupType: "account",
      id: account?.id ?? "",
      name: account?.company ?? "",
      type: account?.type ?? "",
      tier: account?.tier ?? "",
      createdAt: account?.createdAt ?? "",
    };

    if (account?.organisation?.id) {
      segmentData.parentGroupId = account.organisation.id;
    }

    window.analytics.group(
      account?.id ?? "",
      { ...segmentData },
      {
        groupId: account?.id ?? "",
        userId: id ?? "",
      },
    );

    if (account?.organisation?.id) {
      window.analytics.group(account.organisation.id, {
        groupType: "organization",
        id: account.organisation.id,
        name: account.organisation.name ?? "",
        createdAt: account.organisation.createdAt ?? "",
        updatedAt: account.organisation.updatedAt ?? "",
      });
    }
  }, [userId, accountId, organisationId]);

  return null;
};

const App = () => {
  useEffect(() => {
    //if user has old encrypted local storage, clear it
    if (localStorage.getItem("persist:primary")) {
      localStorage.removeItem("persist:primary");
    }
  }, []);

  return (
    <IntercomProvider appId={INTERCOM_APP_ID} autoBoot>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <SegmentIdentify />
          <ToastContainer />
          <ReduxRouter history={history} routerSelector={routerSelector}>
            <Navigation />
          </ReduxRouter>
        </PersistGate>
      </Provider>
    </IntercomProvider>
  );
};
export default App;
